import logger from 'src/utils/logger/logger';
export default function detection(agent) {
  let comp_agent = agent.indexOf('cloudtv') != -1;
  let comp_agent_2 = agent.indexOf('CloudTV') != -1;
  if (comp_agent || comp_agent_2) {
    logger.info('[arris detection] detected');
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/arris/detection.js